// CDMX-16341: a CQA_CLOSED case is terminal and read-only. Combine the case's
// closed-ness with the existing process-status editability flag so every surface
// already gated by `editable` (codes, charges, assessments, questions) blocks.
export const CQA_CLOSED_STATUS = 'CQA_CLOSED';

export const deriveClosedAwareEditable = (
  editable: boolean | undefined,
  status: string | undefined,
): boolean => !!editable && status !== CQA_CLOSED_STATUS;
